module.exports = __webpack_public_path__ + "media/images/talent/feature-04-726b4ddbbd02c3c05f3ddc50bcbab05d.png";